export default "__VITE_ASSET__BPUVyWzg__"